import Config from '@/config'

export default class UtilService {
  constructor(http) {
    this._http = http
  }

  async devolveMesAnoAtual() {
    const { data } = await this._http.get('/api/utils/mes-ano-atual')
    return data
  }

  obterDataVirada() {
    const raw =
      Config?.DATA_VIRADA ||
      Config?.DATA_VIRADA_MARGEM ||
      (typeof window !== 'undefined' &&
        window.$environment &&
        (window.$environment.DATA_VIRADA ||
          window.$environment.DATA_VIRADA_MARGEM)) ||
      '26/10/2026'

    if (typeof raw === 'string') {
      const trimmed = raw.trim()
      if (trimmed.includes('/')) {
        const parts = trimmed.split('/')
        const dia = parseInt(parts[0], 10)
        const mes = parseInt(parts[1], 10)
        const ano = parseInt(parts[2], 10)
        if (!isNaN(ano) && !isNaN(mes) && !isNaN(dia)) {
          const d = new Date(ano, mes - 1, dia)
          d.setHours(0, 0, 0, 0)
          return d
        }
      } else if (trimmed.includes('-')) {
        const parts = trimmed.split('-')
        const ano = parseInt(parts[0], 10)
        const mes = parseInt(parts[1], 10)
        const dia = parseInt(parts[2], 10)
        if (!isNaN(ano) && !isNaN(mes) && !isNaN(dia)) {
          const d = new Date(ano, mes - 1, dia)
          d.setHours(0, 0, 0, 0)
          return d
        }
      }
    } else if (raw instanceof Date) {
      const d = new Date(raw.getTime())
      d.setHours(0, 0, 0, 0)
      return d
    }

    const defaultDate = new Date(2026, 9, 26)
    defaultDate.setHours(0, 0, 0, 0)
    return defaultDate
  }

  getDataVirada() {
    return this.obterDataVirada()
  }

  getDataViradaFormatada() {
    const raw =
      Config?.DATA_VIRADA ||
      Config?.DATA_VIRADA_MARGEM ||
      (typeof window !== 'undefined' &&
        window.$environment &&
        (window.$environment.DATA_VIRADA ||
          window.$environment.DATA_VIRADA_MARGEM))
    if (typeof raw === 'string' && raw.includes('/')) {
      return raw.trim()
    }
    const d = this.obterDataVirada()
    const dia = String(d.getDate()).padStart(2, '0')
    const mes = String(d.getMonth() + 1).padStart(2, '0')
    const ano = d.getFullYear()
    return `${dia}/${mes}/${ano}`
  }

  isDataAtualPosteriorOuIgualLimiteBensDuraveis(dataAtual) {
    const dataLimite = this.obterDataVirada()
    if (dataAtual && dataAtual.ano && dataAtual.mes && dataAtual.dia) {
      const dataServidor = new Date(
        dataAtual.ano,
        dataAtual.mes - 1,
        dataAtual.dia,
      )
      dataServidor.setHours(0, 0, 0, 0)
      return dataServidor >= dataLimite
    }
    const hoje = new Date()
    hoje.setHours(0, 0, 0, 0)
    return hoje >= dataLimite
  }

  async verificarBloqueioBensDuraveis() {
    try {
      const dataAtual = await this.devolveMesAnoAtual()
      return this.isDataAtualPosteriorOuIgualLimiteBensDuraveis(dataAtual)
    } catch (e) {
      return this.isDataAtualPosteriorOuIgualLimiteBensDuraveis(null)
    }
  }

  async verificarViradaCartaoBeneficio() {
    return this.verificarBloqueioBensDuraveis()
  }
}
